module.exports = __webpack_public_path__ + "img/alarm-clock.5e7ef172.png";